import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseCard from "../../../theme/cards/BaseCard";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import { useSelector } from "react-redux";

export const WarehouseBatchCard = (props) => {
    const theme = useTheme();
    
    const { t,i18n } = useTranslation();

    let status = props.state;
    let labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey";
    let labeltext = t('unknown');
    switch(status){
        case "notreceived":
            labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey"
            labeltext = t('not_received');
            break;
        case "partlyreceived":
            labelcolor = "blue"
            labeltext = t('partly_received');
            break;
        case "fullyreceived":
            labelcolor = "green"
            labeltext = t('fully_received');
            break;
        default:
            labelcolor = "red"
            labeltext = t('unknown');
            break;
    }

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box>
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <Text bold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{props.id}</Text>
                        }
                    </Box>

                    <Box
                        sx={{
                            mt:4,
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <>
                                <Text>{props.userName}</Text>
                                <Text light>{props.warehouse?.name}</Text>
                            </>
                        }
                    </Box>

                    <TopRight>
                        <CardLabel hasright variant={labelcolor} position="child-tr">
                            {labeltext}
                        </CardLabel>
                        <CardLabel 
                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                            hasleft 
                            colorflip={theme.palette.mode !== "dark"}
                            position="child-tr"
                        >
                            {props.skeleton ? "N/A" : props.orderCount}
                        </CardLabel>
                    </TopRight>
                </Box>
            </Box>
        </BaseCard>
    )
}


export const ProductBatchCard = (props) => {
    const theme = useTheme();
    
    const { t,i18n } = useTranslation();
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);


    let date = new Date(props.bbDate);
    let now = new Date();
    let diffTime = date.getTime() - now.getTime();
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    let labelcolor = "primary";
    if (diffDays <= 30) {
        labelcolor = "red";
    } else if (diffDays <= 60) {
        labelcolor = "orange";
    }
    

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:'column',
                        }}
                    >
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/> 
                            :
                            <>
                                <Text semibold>{props.number}</Text>
                                {isFulfilment &&
                                    <Text light>{props.relation ?? t("unknown")}</Text>
                                }
                            </>
                        }
                    </Box>

                    <Box
                        sx={{
                            mt:3,
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/> 
                            :
                            <>
                                <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{props.sku}</Text>
                                {isFulfilment &&
                                    <Text light>{props.description}</Text>
                                }
                            </>
                        }
                    </Box>

                    <TopRight>
                        <CardLabel 
                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                            hasright 
                            fitted
                            position="child-tr"
                        >
                            {props.total_available + " / " + props.total_quantity}
                        </CardLabel>
                        <CardLabel 
                            fitted 
                            hasleft 
                            variant={labelcolor} 
                            position="child-tr"
                            sx={{
                                whiteSpace:"nowrap"
                            }}
                        >
                            {date.toLocaleDateString(i18n.language)}
                        </CardLabel>
                    </TopRight>
                </Box>
            </Box>
        </BaseCard>
    )
}
